<template>
  <span class="goHomeBtn">
    <slot name="goHomeBtn">
      <b-button
        id="goHome"
        type="button"
        :variant="btnVariant"
        :size="btnSize"
        :class="btnClass"
        @click="isHousehold ? goHousehold() : goHome()"
        >{{ btnName }}</b-button
      >
    </slot>
  </span>
</template>
<script>
import UserMixin from '@/mixins/user';
import CommonApiMixin from '@/mixins/commonApi';

export default {
  name: 'GoHomeBtn',

  mixins: [UserMixin, CommonApiMixin],

  props: {
    btnSize: {
      type: String,
      default: '',
    },
    btnClass: {
      type: String,
      default: '',
    },
    btnVariant: {
      type: String,
      default: '',
    },
    btnName: {
      type: String,
      default: '',
    },
    // 戶役政 開關
    isHousehold: {
      type: Boolean,
      default: false,
    },
    householdUUId: {
      type: String,
      default: '',
    },
    // UUID 查詢 的cache資料
    resQueryCacheData: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    goHome() {
      this.$router.push({
        name: 'home',
      });
    },

    // 回戶役政查詢頁
    goHousehold() {
      this.$deleteCache(this.resQueryCacheData);
    },
    // 使用共用API結果
    success(type, res, otherObj) {
      console.log(otherObj);
      const resObj = res.data.object;
      switch (type) {
        case 'deleteCache':
          if (resObj === true) {
            this.$clearCookie('householdUUId', this.householdUUId);
            this.$router.push({
              name: 'householdInquiry',
            });
          }
          break;
        default:
          break;
      }
    },
    fail(type, error, other) {
      console.log('fail', type, error, other);
      switch (type) {
        default:
          break;
      }
      this.apiLoading = false;
    },
  },
};
</script>
